import "@/App.css";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Manifesto } from "@/components/site/Manifesto";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { Contact } from "@/components/site/Contact";
import { NotFound } from "@/components/site/NotFound";

function App() {
  const path = window.location.pathname;
  const isHome = path === "/" || path === "" || path === "/index.html";

  if (!isHome) {
    return <NotFound />;
  }

  return (
    <SmoothScroll>
      <div className="App" data-testid="app-root">
        <div className="grain-overlay" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <Manifesto />
          <About />
          <Testimonials />
          <Contact />
        </main>
      </div>
    </SmoothScroll>
  );
}

export default App;
